import { ThumbsUp, ThumbsDown, CheckCircle, XCircle } from "lucide-react";

const CATEGORY_COLORS = {
  Climate: "#10B981", Housing: "#3B82F6", Economy: "#F59E0B", Indigenous: "#DC2626",
  Disability: "#8B5CF6", Environment: "#059669", Integrity: "#6366F1", Defence: "#1E40AF",
  Education: "#0EA5E9", "Social Policy": "#EC4899", "Gambling Reform": "#D97706",
  "Foreign Policy": "#64748B", Energy: "#EF4444", Immigration: "#7C3AED",
  Agriculture: "#065F46", "Digital Safety": "#0891B2", "Human Rights": "#BE185D",
  default: "#6B7280",
};

export function VotingRecordSection({ keyVotes, totalVotes, surface, text, textSec }) {
  if (!totalVotes || totalVotes === 0) return null;
  return (
    <section data-testid="voting-record-section">
      <h2 className="text-xl font-black mb-4 pb-2 border-b-2 border-black" style={{ color: text, fontFamily: "Outfit, sans-serif" }}>
        Voting Record
        <span className="text-sm font-bold ml-2" style={{ color: textSec }}>({totalVotes} key votes)</span>
      </h2>
      <div className="space-y-3">
        {keyVotes.map((vote) => {
          const catColor = CATEGORY_COLORS[vote.category] || CATEGORY_COLORS.default;
          return (
            <div key={vote.id} className="border-2 border-black p-4" style={{ backgroundColor: surface, boxShadow: "2px 2px 0 #000" }} data-testid={`vote-record-${vote.id}`}>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 pt-0.5">
                  {vote.vote === "aye" ? (
                    <div className="flex items-center gap-1 px-2 py-0.5 border-2 border-black text-xs font-black text-white" style={{ backgroundColor: "#10B981" }}>
                      <ThumbsUp className="w-3 h-3" /> AYE
                    </div>
                  ) : (
                    <div className="flex items-center gap-1 px-2 py-0.5 border-2 border-black text-xs font-black text-white" style={{ backgroundColor: "#EF4444" }}>
                      <ThumbsDown className="w-3 h-3" /> NO
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="font-black text-sm" style={{ color: text }}>{vote.bill}</span>
                    <span className="text-xs font-bold" style={{ color: textSec }}>{vote.date}</span>
                    <span className="text-xs font-bold px-1.5 py-0.5 border border-current" style={{ color: catColor }}>{vote.category}</span>
                    <div className="flex items-center gap-1 text-xs font-bold" style={{ color: vote.passed ? "#10B981" : "#EF4444" }}>
                      {vote.passed ? <><CheckCircle className="w-3 h-3" /> Passed</> : <><XCircle className="w-3 h-3" /> Not passed</>}
                    </div>
                  </div>
                  <p className="text-xs leading-relaxed" style={{ color: textSec }}>{vote.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
